import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthBaseQuery } from './baseQuery';

export const reportApi = createApi({
  reducerPath: 'reportApi',
  baseQuery: createAuthBaseQuery(),
  tagTypes: ['Report'],
  endpoints: (builder) => ({
    getReports: builder.query<unknown[], void>({
      query: () => 'reports',
      providesTags: ['Report'],
    }),
    generateReport: builder.mutation<unknown, Record<string, unknown>>({
      query: (body) => ({ url: 'reports/generate', method: 'POST', body }),
      invalidatesTags: ['Report'],
    }),
  }),
});

export const { useGetReportsQuery, useGenerateReportMutation } = reportApi;
